import { render, staticRenderFns } from "./brand_list.vue?vue&type=template&id=4839e51c&scoped=true"
import script from "./brand_list.vue?vue&type=script&lang=js"
export * from "./brand_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4839e51c",
  null
  
)

export default component.exports